import RegisterOTPPage from './RegisterOTPPage';
import { createOtpSubmitData } from './RegisterOTPPage';

export default RegisterOTPPage;
export { createOtpSubmitData };
